<div
  class="director-section"
  [style.background-color]="mainBackgroundColor || '#80ff02'"
>
  <h2 [style.color]="mainColor || '#000000'">What Parents are saying</h2>
  <div class="wrapper">
    <div class="director-desk" *ngIf="currentReview">
      <div class="director-wrapper">
        <div class="image">
          <!-- <img
            [src]="currentReview.url || '../../assets/images/default.jpeg'"
            alt="{{ currentReview.name }}"
          /> -->
          <div
            class="background-image"
            [style.background-image]="'url(' + currentReview.url + ')'"
          ></div>
          <div class="back-layer"></div>
        </div>
      </div>
      <div class="director-message">
        <p [style.color]="mainColor || '#000000'">
          <!-- {{ handleDescription(currentReview.description) }}
          <span *ngIf="currentReview.description.split(' ').length > 10">
            <span (click)="toggleDescription()" class="read">
              {{ showFullDescription ? "Read less" : "Read more" }}
            </span>
          </span> -->
          {{ currentReview.description }}
        </p>
        <p [style.color]="mainColor || '#000000'">Highly recommended</p>
        <p [style.color]="mainColor || '#000000'">Warm regards,</p>
        <div class="abt-director">
          <h3 [style.color]="mainColor || '#000'">
            {{ currentReview.parentName }}
          </h3>
          <p [style.color]="mainColor || '#000'">
            C/O {{ currentReview.childName }}
          </p>
        </div>
        <div class="controls">
          <button
            (click)="previousReview()"
            [style.color]="mainColor || '#000'"
            [style.border-color]="mainColor || '#000'"
          >
            &#8592;
          </button>
          <button
            (click)="nextReview()"
            [style.color]="mainColor || '#000'"
            [style.border-color]="mainColor || '#000'"
          >
            &#8594;
          </button>
          <!-- <div class="controls">
            <button (click)="previousItem()" class="nav-button">←</button>
            <button (click)="nextItem()" class="next-button">
              <svg *ngIf="countdownValue" width="60" height="60">
                <circle
                  class="countdown-circle"
                  cx="30"
                  cy="30"
                  r="25"
                  stroke="red"
                  stroke-width="11"
                  fill="transparent"
                  [attr.stroke-dasharray]="circumference"
                  [attr.stroke-dashoffset]="getDashOffset()"
                ></circle>
              </svg>
              →
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
